import Config from "react-native-config";

export const API_URL = Config.API_URL;
export const STATIC_FILES_URL = Config.STATIC_FILES_URL;

export const WEB_ANALITYCS_API_KEY = Config.WEB_ANALITYCS_API_KEY;

export const URL_GEOCODE = Config.URL_GEOCODE;
export const MAPS_API_KEY = Config.MAPS_API_KEY;

export const SENTRY_AUTH_TOKEN = Config.SENTRY_AUTH_TOKEN;
export const SENTRY_DNS = Config.SENTRY_DNS;
